import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";

export function UseMotorRouting() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getParts = (myPC, callback) => {
    MyAxios.get(`Admin_Logestic_DeliveryManage/parts`, {
      headers: {
        pageCondition: myPC,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetRoutes = (DeliveryDate, DeliveryPart, callback) => {
    MyAxios.get(`Admin_Logestic_MotorRouting/routes`, {
      headers: {
        Conditions: JSON.stringify({
          DeliveryDate: DeliveryDate,
          DeliveryPart: DeliveryPart,
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetLocations = (DeliveryDate, DeliveryPart, callback, bool) => {
    MyAxios.get(`Admin_Logestic_MotorRouting`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({
          DeliveryDate: DeliveryDate,
          DeliveryPart: DeliveryPart,
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      } else {
        callback();
      }
    });
  };

  const GetOrderByLogesticId = (model, callback) => {
    MyAxios.get(`Admin_Logestic_MotorRouting/order`, {
      headers: {
        Conditions: JSON.stringify(model),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      } else {
        callback();
      }
    });
  };

  const GetlocateLogesticId = (model, callback) => {
    MyAxios.get(`Admin_Logestic_MotorRouting/locate`, {
      headers: {
        Conditions: JSON.stringify(model),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      } else {
        callback();
      }
    });
  };

  const AutoRout = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_MotorRouting/autorout`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };
  const EditLocation = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_MotorRouting/location`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const EditSendGroup = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_MotorRouting/rout`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getParts,
    GetRoutes,
    GetLocations,
    GetOrderByLogesticId,
    EditLocation,
    EditSendGroup,
    GetlocateLogesticId,
    AutoRout,
  };
}
